import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import VideoSection from './sections/VideoSection';
import WhyVtrenderSection from './sections/WhyVtrenderSection';
import InsidePlatformSection from './sections/InsidePlatformSection';
import FeatureGridSection from './sections/FeatureGridSection';
import VideoFeaturesSection from './sections/VideoFeaturesSection';
import SocialProofSection from './sections/SocialProofSection';
import PricingSection from './sections/PricingSection';
import PrivateFooterSection from './sections/PrivateFooter';
import CountdownBar from './demo-upgrade/sections/CountdownBar';
import DemoHeroSection from './demo-upgrade/sections/HeroSection';
import FeaturedPlan from './demo-upgrade/sections/FeaturedPlan';
import Testimonials from './demo-upgrade/sections/Testimonials';
import FeatureComparison from './demo-upgrade/sections/FeatureComparison';
import FAQ from './demo-upgrade/sections/FAQ';
import TrustBadges from './demo-upgrade/sections/TrustBadges';
import DemoFooter from './demo-upgrade/sections/Footer';
import './LandingPage.css';
import './demo-upgrade/DemoUpgradeLandingPage.css';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../common/hooks/useAuth';
import useRefreshToken from '../../common/hooks/useRefreshToken';
import useDemoEligibility from './demo-upgrade/useDemoEligibility';
import YearRecapPopup from '../YearRecapPopup';

const AuthLandingPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { auth } = useAuth();
  const refresh = useRefreshToken();
  const navigate = useNavigate();
  const { isChecking, isEligible, demoData } = useDemoEligibility();
  const [showYearRecap, setShowYearRecap] = useState(true);

  useEffect(() => {
    if (auth?.accessToken) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, [auth?.accessToken]);

  // Another tab logged in -> refresh cookie, then enter the app
  useEffect(() => {
    const onStorage = async (event) => {
      if (!event.key?.startsWith('vt_login_lock:') || !event.newValue) {
        return;
      }
      try {
        await refresh();
        navigate('/market-profile', { replace: true });
      } catch {
        // Stay on auth-landing if session still invalid
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [refresh, navigate]);

  useEffect(() => {
    if (isEligible) {
      document.title = "Elite Demo Member Exclusive - Use Code DEMO35 | Vtrender™ Charts";
    } else {
      document.title = "Vtrender™ Charts";
    }
  }, [isEligible]);

  // Show loading state while checking
  if (isChecking) {
    return null;
  }

  // Show demo upgrade landing page if eligible
  if (isEligible) {
    const minutesRemaining = demoData?.minutesRemaining || 0;
    const expiryTime = new Date(Date.now() + minutesRemaining * 60 * 1000).getTime();

    return (
      <div className="demo-upgrade-landing-page landing-page">
        <CountdownBar expiryTime={expiryTime} />
        <DemoHeroSection />
        <FeaturedPlan />
        <Testimonials />
        <FeatureComparison />
        <FAQ />
        <TrustBadges />
        <DemoFooter />
      </div>
    );
  }

  // Show normal landing page if not eligible
  return (
    <div className="landing-page">
      <HeroSection />
      <VideoFeaturesSection />
      <WhyVtrenderSection />
      <InsidePlatformSection />
      <FeatureGridSection />
      <SocialProofSection />
      {/* <PricingSection /> */}
      <VideoSection />
      <PrivateFooterSection />
      {/* <YearRecapPopup 
        open={showYearRecap}
        onClose={() => setShowYearRecap(false)}
        delayMs={1200}
      /> */}
    </div>
  );
};

export default AuthLandingPage;